import {
	axiosErrorHandler,
	get,
	post,
	put,
	deletes,
} from 'models/shared/helpers/axiosInstance';
import { buildPathWithQueryParams } from 'models/shared/helpers/utils';
import { Company } from 'models/companies/interfaces/companies.interface';
import {
	CreateCompanyDto,
	UpdateCompanyDto,
	CompanyFilterDto,
} from '../interfaces/company-management.interface';
import { City } from '../interfaces/city.interface';

const baseCompanyPath = '/v1/companies';

export const fetchCompanies = async (dto?: CompanyFilterDto) => {
	try {
		const url = dto
			? buildPathWithQueryParams(baseCompanyPath, dto)
			: baseCompanyPath;
		const res = await get<Company[]>(url);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const fetchCompany = async (id: string) => {
	try {
		const url = `${baseCompanyPath}/${id}`;
		const res = await get<Company>(url);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const createCompany = async (dto: CreateCompanyDto) => {
	try {
		const res = await post<Company>(baseCompanyPath, dto);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const updateCompany = async (id: string, dto: UpdateCompanyDto) => {
	try {
		const url = `${baseCompanyPath}/${id}`;
		const res = await put<Company>(url, dto);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const deleteCompany = async (id: string) => {
	try {
		const url = `${baseCompanyPath}/${id}`;
		await deletes(url);
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const cancelCompany = async (id: string) => {
	try {
		const url = `${baseCompanyPath}/${id}/cancel`;
		const res = await put<Company>(url);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

const baseCityPath = '/v1/cities';

export const fetchCities = async () => {
	try {
		const res = await get<
			{ count: number; pages: number; page: number; data: City[] } | City[]
		>(baseCityPath);

		if (Array.isArray(res.data)) {
			return res.data;
		}
		if (res.data && typeof res.data === 'object' && 'data' in res.data) {
			return res.data.data || [];
		}
		return [];
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};
